import type { User } from '@repo-level/core-front';
import { AuthContext } from '@repo-level/core-front';
import { useCallback, useContext, useEffect, useRef } from 'react';
import { syncRiskSegment } from '../helpers/syncRiskSegment';

export const useRiskSegmentSync = () => {
  const { refreshUser } = useContext(AuthContext);
  const refreshUserRef = useRef(refreshUser);
  const syncedUserIdRef = useRef<number | null>(null);

  useEffect(() => {
    refreshUserRef.current = refreshUser;
  }, [refreshUser]);

  return useCallback(
    (user: Pick<User, 'id' | 'statuses'> | undefined | null) => {
      if (!user?.id) return;
      if (syncedUserIdRef.current === user.id) return;
      syncedUserIdRef.current = user.id;
      void syncRiskSegment(user, refreshUserRef.current);
    },
    []
  );
};
